import axios from 'axios';
import { getToken } from '../token';
import { API_CALL_ERROR, CUSTOMERS_ENDPOINT } from './APIConstants';

export async function addEditCustomer(requestorId, payload) {
  const authToken = getToken();
  try {
    const { data } = await axios.post(CUSTOMERS_ENDPOINT, payload, {
      params: {
        requestorId: requestorId,
        authToken: authToken,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}

export async function getCustomers() {
  try {
    const { data } = await axios.get(CUSTOMERS_ENDPOINT, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}

export async function getCustomerById(customerId) {
  try {
    const { data } = await axios.get(CUSTOMERS_ENDPOINT, {
      params: {
        customerId: customerId,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}

export async function getCustomerBySearch(search) {
  try {
    const { data } = await axios.get(CUSTOMERS_ENDPOINT, {
      params: {
        search: search,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}
